import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b392832"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "row"
}
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = {
  key: 0,
  class: "text-danger validation-summary-errors",
  "data-valmsg-summary": "true"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-database-add" }, null, -1))
const _hoisted_7 = { class: "col-3 p-2" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "col-5 p-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { class: "col-2 p-2 text-right" }
const _hoisted_12 = { class: "col-2 p-2 text-right" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bookmark-plus" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { "aria-label": "breadcrumb" }
const _hoisted_18 = { class: "breadcrumb" }
const _hoisted_19 = { class: "breadcrumb-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-compact-right" }, null, -1))
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "col-3 p-2" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "col-9 p-2" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "col-3 p-2" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "col-5 p-2" }
const _hoisted_30 = { class: "col-2 p-2" }
const _hoisted_31 = { class: "col-2 p-2 text-right" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bookmark-plus" }, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 2,
  class: "row"
}
const _hoisted_36 = { class: "col-12 bg-light custom-home-size" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "custom-home-head" }, "shopleech", -1))
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-sm-6 col-lg-4" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, " Products ", -1))
const _hoisted_42 = { class: "col-6 text-right" }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, " Contributions ", -1))
const _hoisted_45 = { class: "col-6 text-right" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, " Accounts ", -1))
const _hoisted_48 = { class: "col-6 text-right" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6 col-lg-4" }, null, -1))
const _hoisted_50 = {
  key: 3,
  class: "row"
}
const _hoisted_51 = { class: "row fixed-bottom p-3 col-xl-4 col-lg-5 col-md-6 col-sm-7" }
const _hoisted_52 = { class: "col-6" }
const _hoisted_53 = { class: "col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock(_component_Header, {
          key: 0,
          title: ""
        }))
      : _createCommentVNode("", true),
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMsg != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, _toDisplayString(_ctx.errorMsg), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getKeyword().trim().length >= 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addOffer && _ctx.addOffer(...args))),
                      class: "border-0"
                    }, [
                      _hoisted_6,
                      _createTextVNode(" lisa pakkumine ")
                    ])
                  ]),
                  _createElementVNode("small", null, "Leitud tooteid: " + _toDisplayString(_ctx.getProductList().length), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getProductList(), (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: "row"
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("img", {
                          src: _ctx.getProductImageByBarcode(item.barcode),
                          alt: "",
                          height: "86"
                        }, null, 8, _hoisted_8)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_RouterLink, {
                          to: { name: 'product-details', params: { id: item.id } },
                          class: "text-dark"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _hoisted_10,
                        _createElementVNode("small", null, _toDisplayString(item.barcode), 1)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_RouterLink, {
                          to: { name: 'product-details', params: { id: item.id } },
                          class: "text-dark"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" €" + _toDisplayString(item.minPrice), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.addBookmark(item.id)),
                          class: "border-0",
                          style: _normalizeStyle({backgroundColor: _ctx.bookmarkIsActive(item.id) ? 'lightgreen' : 'lightgray'})
                        }, _hoisted_15, 12, _hoisted_13)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.getKeyword().trim().length < 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("nav", _hoisted_17, [
                    _createElementVNode("ol", _hoisted_18, [
                      _createElementVNode("li", _hoisted_19, [
                        _createElementVNode("button", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentCategoryId=0)),
                          class: "border-0 small"
                        }, [
                          _hoisted_20,
                          _createTextVNode(" Kataloog ")
                        ])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getBreadcrumbs(_ctx.currentCategoryId), (breadcrumb) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "breadcrumb-item",
                          key: breadcrumb.id
                        }, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.currentCategoryId=breadcrumb.id),
                            class: "border-0 small"
                          }, _toDisplayString(breadcrumb.name), 9, _hoisted_21)
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFilteredCategoryList(_ctx.currentCategoryId), (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: "border row"
                    }, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("img", {
                          src: _ctx.getCategoryImageByType(item.categoryTypeCode),
                          alt: "",
                          height: "86"
                        }, null, 8, _hoisted_23)
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.clickCategory(item.id)),
                          class: "border-0",
                          style: {"font-size":"22px","background-color":"white"}
                        }, _toDisplayString(item.name), 9, _hoisted_25)
                      ])
                    ]))
                  }), 128)),
                  (_ctx.currentCategoryId > 0 && _ctx.getProductList().length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getProductList(), (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.id,
                            class: "border row"
                          }, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("img", {
                                src: _ctx.getProductImageByBarcode(item.barcode),
                                alt: "",
                                height: "86"
                              }, null, 8, _hoisted_28)
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", null, [
                                _createVNode(_component_RouterLink, {
                                  to: { name: 'product-details', params: { id: item.id } },
                                  class: "text-dark"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              _createElementVNode("small", null, _toDisplayString(item.barcode), 1)
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _createVNode(_component_RouterLink, {
                                to: { name: 'product-details', params: { id: item.id } },
                                class: "text-dark"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" €" + _toDisplayString(item.minPrice), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("button", {
                                onClick: ($event: any) => (_ctx.addBookmark(item.id)),
                                class: "border-0",
                                style: _normalizeStyle({backgroundColor: _ctx.bookmarkIsActive(item.id) ? 'green' : 'lightgray'})
                              }, _hoisted_34, 12, _hoisted_32)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isAuthenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.getStats().numOfProducts), 1)
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.getStats().numOfPriceUpdates), 1)
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.getStats().numOfUsers), 1)
                ])
              ]),
              _hoisted_49
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isAuthenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createVNode(_component_RouterLink, {
                to: { name: 'identity-login'},
                class: "btn btn-secondary btn-lg w-100"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Login ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createVNode(_component_RouterLink, {
                to: { name: 'identity-register'},
                class: "btn btn-primary btn-lg w-100"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Register ")
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}